<template>
  <div class="">
    <main class="main">
      <section class="section">
        <div class="container container--medium">

          <div class="section__top season-saved__header">
            <div class="season-saved__icon">
              <i class="fa-solid fa-circle-check"></i>
            </div>
            <h1 class="section__title">Цели сохранены</h1>
            <p class="season-saved__meta">
              {{ seasonInfo.title }} · {{ seasonInfo.startDate }} — {{ seasonInfo.endDate }}
            </p>
          </div>

          <div class="season-saved__body">
            <div v-if="myActivities.length" class="season-saved__list">
              <div
                v-for="a in myActivities"
                :key="a.code"
                class="season-saved__card"
              >
                <p class="season-saved__card-label">
                  <i class="fa-solid" :class="a.icon"></i>
                  {{ a.name }}
                </p>
                <p class="season-saved__card-cluster">
                  Кластер {{ a.clusterId }}
                  <span class="season-saved__card-range">({{ clusterLabel(a.clusterId) }})</span>
                </p>
                <ul class="season-saved__card-info">
                  <li class="season-saved__card-info-item">
                    <span class="season-saved__card-info-label">Цель</span>
                    <span class="season-saved__card-info-value">{{ a.goalKm }} км</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="season-saved__note">
              <p class="season-saved__note-title">
                <i class="fa-solid fa-circle-info"></i>
                Сбор статистики по&nbsp;кластерам начинается с&nbsp;1&nbsp;мая&nbsp;2026&nbsp;года
              </p>
              <p class="season-saved__note-text">
                Рейтинг и&nbsp;статистика по&nbsp;кластерам в&nbsp;разрезе активностей&nbsp;— в&nbsp;разработке.
                Как только они появятся, вы&nbsp;увидите их&nbsp;в&nbsp;разделах «Статистика
                клуба» и&nbsp;«Рейтинги».
              </p>
            </div>

            <div class="season-saved__actions">
              <router-link to="/profile" class="button button-accent-1 season-saved__btn">
                В&nbsp;личный кабинет
              </router-link>
            </div>
          </div>

        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SeasonSaved',

  computed: {
    ...mapGetters('season', ['seasonInfo', 'myActivities', 'clusterLabel']),
  },
}
</script>

<style>
.season-saved__header {
  margin-bottom: 40px;
  row-gap: 10px;
}

.season-saved__icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #e6f4ec;
  color: #1a7a4a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  margin: 0 auto 16px;
}

.season-saved__meta {
  font-size: 15px;
  color: #6b7a8f;
  text-align: center;
  margin: 0;
}

.season-saved__body {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 720px;
  margin: 0 auto;
}

.season-saved__list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media screen and (max-width: 640px) {
  .season-saved__list {
    grid-template-columns: 1fr;
  }
}

.season-saved__card {
  background: #fff;
  border-radius: 12px;
  padding: 22px 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,.07);
}

.season-saved__card-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6b7a8f;
  margin: 0 0 10px;
}

.season-saved__card-label i {
  font-size: 14px;
  color: #6b7a8f;
}

.season-saved__card-cluster {
  font-size: 20px;
  font-weight: 700;
  color: #012653;
  margin: 0 0 14px;
}

.season-saved__card-range {
  font-weight: 500;
  color: #6b7a8f;
  font-size: 15px;
}

.season-saved__card-info {
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid #EDF3FA;
}

.season-saved__card-info-item {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;
  font-size: 14px;
}

.season-saved__card-info-label {
  color: #6b7a8f;
}

.season-saved__card-info-value {
  color: #012653;
  font-weight: 600;
  text-align: right;
}

.season-saved__note {
  background: #EDF3FA;
  border-radius: 12px;
  padding: 20px 22px;
}

.season-saved__note-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #012653;
  margin: 0 0 8px;
}

.season-saved__note-title i {
  font-size: 16px;
  opacity: 0.75;
}

.season-saved__note-text {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  margin: 0;
}

.season-saved__actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}

.season-saved__btn {
  min-width: 220px;
  text-align: center;
}

@media screen and (max-width: 520px) {
  .season-saved__actions {
    flex-direction: column;
  }
  .season-saved__btn {
    width: 100%;
  }
}
</style>
